import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sessionId = params.get("session_id");
      // Where should we send the user afterwards? Set by Login/Register/Checkout
      // right before starting the OAuth redirect. Falls back to /account.
      const nextUrl = sessionStorage.getItem("goshi_auth_next") || "/account";
      sessionStorage.removeItem("goshi_auth_next");
      if (!sessionId) { nav("/login"); return; }
      try {
        await api.post("/auth/emergent/session", { session_id: sessionId });
        await refresh();
        // Clear the fragment so a back-navigation doesn't re-trigger this flow.
        window.history.replaceState({}, "", nextUrl);
        toast.success("Signed in with Google");
        nav(nextUrl);
      } catch {
        nav("/login");
      }
    };
    run();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted text-sm uppercase tracking-[0.3em]">Signing you in…</p>
    </div>
  );
}
